import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { BaseService } from '@services/base-service.service';
import { IQRBatchBrandItem, IQRBatchDetailItem, IQRBatchForm, IQRBatchForm_BrandItem, IQRBatchForm_Response, IQRCodeBatchItem } from './qr-products.interface';
import { API } from '@config/constants/api.constant';
import { EnumQrBatchStatus } from './enum/qr-product.enum';
import { UtilitiesService } from '@services/utilities.service';
import { RolePrivilegeService } from '@services/role-privilege.service';

@Injectable({
  providedIn: 'root',
})
export class QrProductsService {
  constructor(private baseService: BaseService, private router: Router, private utilitiesService: UtilitiesService, private rolePrivilegeService: RolePrivilegeService) {}

  getQRBatchDetail(id: string) {
    return this.baseService.getData<IQRBatchDetailItem>(API.DETAIL_QR_BATCH + id);
  }

  downloadQRBatch(id: string) {
    return this.baseService.getData<IQRCodeBatchItem[]>(API.DOWNLOAD_QR_BATCH + id);
  }

  createQRBatch(payload: IQRBatchForm) {
    return this.baseService.postData<IQRBatchForm_Response>(API.CREATE_QR_BATCH, payload);
  }

  isAbleToDownloadBatch(status: string) {
    return !!(status && status === Object.keys(EnumQrBatchStatus)[0]);
  }

  isBatchOnProgress(status: string) {
    const _enumValue = this.utilitiesService.mapKeyToString(EnumQrBatchStatus, status);
    return _enumValue === EnumQrBatchStatus.ON_PROGRESS;
  }

  generateSelectedBrandFormat(data: IQRBatchForm_BrandItem[], source: IQRBatchBrandItem[]) {
    // match id and combine data
    return data
      .map((_d) => {
        const { brand_id, generate_qty } = _d;

        const _matchEl = source.find((_s) => _s.id === brand_id);
        if (!_matchEl) {
          return null;
        }

        return {
          id: brand_id,
          name: _matchEl.name,
          generate_qty,
        };
      })
      .filter((item) => item !== null);
  }

  routeToListPage() {
    return this.router.navigate(['/products/list-qr-produk']);
  }

  hasListPrivilegeCTA(enumCta: string) {
    return this.rolePrivilegeService.checkPrivilege('PRODUCT_CATALOG', 'LIST_QR_PRODUCT', 'LIST_QR_PRODUCT', enumCta);
  }

  hasDetailPrivilegeCTA(enumCta: string) {
    return this.rolePrivilegeService.checkPrivilege('PRODUCT_CATALOG', 'DETAIL_QR_PRODUCT', enumCta);
  }
}
